import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';

$('.single-book').each(function () {
    const $this = $(this);
    const $btn = $this.find('.btn-shop').first();

    if (getW() > eksmoBP.lgMin) {
        $btn.addClass('btn-shop_big');
    }
});